import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';
import { useLegacyMode } from '@/entities/legacy-mode';
import { DeliveryBranchesPage } from '@/pages/delivery-branches';
import { LegacyBranchesPage } from '@/pages/legacy-branches';
import { requireAuth } from '../require-auth';

/** URL state for the Адреса филиалов screen — free-text search only. */
const deliveryBranchesSearchSchema = z.object({
  search: z.string().optional(),
});

export const Route = createFileRoute('/delivery/branches')({
  // Auth guard — see `require-auth.ts`. Runs before the component mounts,
  // so no query fires without a session.
  beforeLoad: requireAuth,
  validateSearch: deliveryBranchesSearchSchema,
  component: DeliveryBranchesRoute,
});

function DeliveryBranchesRoute() {
  const { search } = Route.useSearch();
  const legacy = useLegacyMode();

  // The legacy screen has no search — the old page filtered client-side over a
  // grid small enough not to need it.
  return legacy ? <LegacyBranchesPage /> : <DeliveryBranchesPage search={search} />;
}
